// extracted by mini-css-extract-plugin
module.exports = {"label":"checkbox_label__Lh7qg"};